import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PrComponiFatturaAvanzataComponent } from './pr-componi-fattura-avanzata';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.pr-componi-fattura-avanzata', {
            url: '/pr-componi-fattura-avanzata',
            params: {
                xmlpath: '',
                requestNotaCredito : false
            },
            ncyBreadcrumb: {
                label: 'Componi Fattura',
                parent: 'home.fatturazione-pr'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Componi fattura e genera XML'
            },
            'views': {
                'homeContent': {
                    template: '<pr-componi-fattura-avanzata flex="100"></pr-componi-fattura-avanzata>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const PrComponiFatturaAvanazataModule: string = ng
    .module('pr-componi-fattura-avanzata', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('prComponiFatturaAvanzata', PrComponiFatturaAvanzataComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/pr-componi-fattura-avanzata/pr-componi-fattura-avanzata.module.ts